// Preset → module mapping (modus-en-modules.md). Single source of truth shared by
// the server (resolveModules) and the client (the create screen's summary), so
// they can never drift.
export const ALL_MODULES_OFF = {
    inzetSchaal: false,
    visibleMeter: false,
    locationChats: false,
    ziener: false,
    beschermer: false,
    schaduw: false,
    earnedOrder: false,
    wisseltoken: false,
    natHout: false,
    variableFires: false,
    pleidooi: false,
};
// Each preset is one tap that bundles modules. Not-yet-built modules are set here
// too: they stay inert until implemented, then light up automatically (forward-
// compatible). 'eigen' is host-defined and relies on explicit toggles.
const familie = { ...ALL_MODULES_OFF, locationChats: true, ziener: true };
const klassiek = {
    ...familie,
    inzetSchaal: true,
    beschermer: true,
    schaduw: true,
    earnedOrder: true,
    variableFires: true,
    natHout: true,
};
const uitdaging = { ...klassiek, visibleMeter: true, wisseltoken: true };
export const PRESET_MODULES = {
    introductie: ALL_MODULES_OFF,
    familie,
    klassiek,
    uitdaging,
    eigen: ALL_MODULES_OFF,
};
// Human-readable Dutch names for each module (used in the create-screen summary).
export const MODULE_LABELS = {
    inzetSchaal: 'Inzet-schaal',
    visibleMeter: 'Zichtbare schade-meter',
    locationChats: 'Privé locatie-chats',
    ziener: 'Ziener',
    beschermer: 'Beschermer',
    schaduw: 'Schaduw',
    earnedOrder: 'Verdiende volgorde',
    wisseltoken: 'Wisseltoken',
    natHout: 'Nat hout',
    variableFires: 'Variabele vuren',
    pleidooi: 'Pleidooi inspreken',
};
// One-line Dutch explanation per module — shown beside each toggle so the host
// knows what they're switching on. Keep them short and player-facing.
export const MODULE_BLURBS = {
    inzetSchaal: 'Kies ’s nachts hoe hard je voedt of saboteert (1–3): meer effect, maar ook meer sporen.',
    visibleMeter: 'Toon de exacte schade van elk vuur, niet alleen brandt / flikkert / gedoofd.',
    locationChats: 'Privé-overleg bij elk vuur, naast het openbare dorpsplein — wie er staat is een aanwijzing.',
    ziener: 'Eén eerlijke onderzoekt elke nacht in het geheim één speler: shapeshifter of niet.',
    beschermer: 'Eén eerlijke schermt elke nacht één vuur af; sabotage sputtert daar zonder schade.',
    schaduw: 'Een shapeshifter met een extra troef: één keer “nat hout” om een onschuldige verdacht te maken.',
    earnedOrder: 'De minst verdachte kiest zijn post het eerst; een vol vuur kun je verdringen.',
    wisseltoken: 'Je claim ligt vast — met een schaars, zichtbaar wisseltoken kun je alsnog van vuur wisselen.',
    natHout: 'Af en toe laat het weer een trouw vuur sputteren; alleen het slachtoffer weet dat het nat hout was.',
    variableFires: 'Vuren verschillen: sommige hebben minder plekken of zijn kwetsbaar (doven sneller).',
    pleidooi: 'Spreek vlak voor de stemming een kort pleidooi in ter verdediging.',
};
// Modules whose behaviour actually exists yet. The rest are set by presets but
// stay inert; the create UI marks them "(binnenkort)". Add to this set as each
// module lands.
export const IMPLEMENTED_MODULES = new Set([
    'inzetSchaal',
    'visibleMeter',
    'locationChats',
    'ziener',
    'beschermer',
    'schaduw',
    'earnedOrder',
    'wisseltoken',
    'natHout',
    'variableFires',
]);
//# sourceMappingURL=presets.js.map